var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('sf-card',{staticClass:"p-0 border-0 bg-transparent",attrs:{"height":"330px","title":_vm.getMessage_('QWCC001234')}},[(_vm.isLoading1)?[_c('bar-chart',{ref:"grpBar",attrs:{"height":280,"chartData":_vm.datacollection1,"options":_vm.optionCollection1}})]:_vm._e()],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }